export default "__VITE_ASSET__FwNBRfF2__"